export default function ({ store, app: { $axios } }) {
  $axios.onRequest((config) => {
    if (config.headers.common) {
      let authCookie = '';
      config.headers.common['Experience'] = store.getters['experience/getExperience'];
      config.headers.common['Accept-Language'] = store.$i18n.locale;

      if (process.server) {
        authCookie =
          getAppCookies(config)['vx.token.local'] ||
          getAppCookies(config)['vx.token.google'] ||
          getAppCookies(config)['vx.token.facebook'];
      } else {
        authCookie =
          store.$cookies.get('vx.token.local') ||
          store.$cookies.get('vx.token.google') ||
          store.$cookies.get('vx.token.facebook');
      }

      if (authCookie) {
        config.headers.common['Authorization'] = authCookie;
      }
    }
  });

  $axios.onError((error) => {
    const code = parseInt(error.response && error.response.status);
    if (code === 401) {
      const domain = process.env.COOKIES_DOMAIN;
      const path = '/';
      store.$cookies.remove('vx.strategy', { domain, path });
      store.$cookies.remove('vx.token.local', { domain, path });
      store.$cookies.remove('vx.token.google', { domain, path });
      store.$cookies.remove('vx.token.facebook', { domain, path });
      store.dispatch('auth/logout');
    }
  });
}

const getAppCookies = (req) => {
  const rawCookies = req.headers.common.cookie ? req.headers.common.cookie.split('; ') : [];
  const parsedCookies = {};
  rawCookies.forEach((rawCookie) => {
    const parsedCookie = rawCookie.split('=');
    parsedCookies[parsedCookie[0]] = parsedCookie[1];
  });

  return parsedCookies;
};
